import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.188 2a.94.94 0 0 0-.938.938v8.124c0 .518.42.938.938.938h1.875v-1.562a.938.938 0 0 1 1.875 0V12h1.875c.517 0 .937-.42.937-.937V2.937A.94.94 0 0 0 9.813 2zM4.5 6.688c0-.172.14-.313.313-.313h.625c.171 0 .312.14.312.313v.625c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.312zm2.188-.313h.625c.171 0 .312.14.312.313v.625c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.312v-.625c0-.172.14-.313.313-.313m1.562.313c0-.172.14-.313.313-.313h.624c.172 0 .313.14.313.313v.625c0 .171-.14.312-.312.312h-.626a.313.313 0 0 1-.312-.312zM4.813 3.875h.625c.171 0 .312.14.312.313v.625c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.312v-.625c0-.172.14-.313.313-.313m1.562.313c0-.172.14-.313.313-.313h.625c.171 0 .312.14.312.313v.625c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.312zm2.188-.313h.624c.172 0 .313.14.313.313v.625c0 .171-.14.312-.312.312h-.626a.313.313 0 0 1-.312-.312v-.625c0-.172.14-.313.313-.313"
    }, null, -1)
  ]))]))
}
export default { render: render }